import { Component, Input } from '@angular/core';

export type ProgressSymbolMode = 'determinate' | 'indeterminate' | 'short';
export type ProgressSymbolDirection = 'vertical' | 'horizontal';

interface FillerStyle {
  transform: string;
}

interface Offset {
  x: string;
  y: string;
}

@Component({
  selector: 'progress-symbol',
  templateUrl: './progress-symbol.component.html',
  styleUrls: [ './progress-symbol.component.scss' ],
})
export class ProgressSymbolComponent
{

  /**
   * Die Transformation führt im Google Chrome bei manchen Browserbreiten zu
   * einen Flackern. Der Fehler ist bei Google bekannt, es besteht jedoch kein
   * Interesse den Fehler zu beheben. Ein Versuch das Flackern durch
   * CSS-Attribute oder durch Pixelschubsereien zu lösen war nicht erfolgreich.
   * Bisher investierte Zeit: ~3h
   */
  public fillerStyle: FillerStyle = {
    transform: '',
  };

  private _value: number = 0;
  private _mode: ProgressSymbolMode = 'indeterminate';
  private _direction: ProgressSymbolDirection = 'horizontal';

  @Input('mode') public set mode(next: ProgressSymbolMode)
  {
    this._mode = next;
    this.updateStyle();
  }

  public get mode(): ProgressSymbolMode
  {
    return this._mode;
  }

  @Input('direction') public set direction(next: ProgressSymbolDirection)
  {
    this._direction = next;
    this.updateStyle();
  }

  @Input('value') public set value(next: number)
  {
    this._value = next;
    this.updateStyle();
  }

  private updateStyle(): void
  {
    const off: Offset =
      this._direction === 'horizontal'
      ? {x: `-${100 - this._value}`, y: '0'}
      : {x: '0', y: `${100 - this._value}`};

    this.fillerStyle = {
      transform: `translate(${off.x}px, ${off.y}px)`
    };
  }

  constructor() {
    this.updateStyle();
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/progress-overlay/progress-symbol.component.ts